<template>
  <div class='table-box'>
    <global-tag>
      <el-form :inline='true' :model='searchlist' size='mini'>
        <el-form-item label='权限名称:'>
          <el-input
            placeholder='输入关键字进行过滤'
            v-model='permissionName'
          ></el-input>
        </el-form-item>
        <el-form-item style='margin: 0'>
          <el-button
            type='primary'
            icon='el-icon-search'
            @click='queryPermissions'
          >查询
          </el-button
          >
        </el-form-item>
      </el-form>
    </global-tag>
    <div class='three' style='margin-top: 12px'>
      <el-button type='primary' size='mini' @click='addForm(0, 0)'
      >新增模块
      </el-button
      >
    </div>
    <div class='table_card' style='margin-top: 6px'>
      <el-table
        size='middle'
        :header-cell-style="{ background: '#f8fafa' }"
        align='center'
        current-row-key
        highlight-current-row
        height='40'
      >
        <el-table-column
          align='center'
          label='权限名称'
        ></el-table-column>
        <el-table-column
          align='center'
          label='路由'
          width='300px'
        ></el-table-column>
        <el-table-column
          align='center'
          label='权限标识'
          width='300px'
        ></el-table-column>
        <el-table-column
          align='center'
          label='排序'
          width='80px'
        ></el-table-column>
        <el-table-column
          align='center'
          label='操作'
          width='240px'
        ></el-table-column>
      </el-table>
      <el-tree
        ref='tree'
        class='filter-tree'
        :data='treedata'
        :props='defaultProps'
        node-key='id'
        :filter-node-method='filterNode'
        default-expand-all
        :expand-on-click-node='false'
        :render-content='renderContent'
      ></el-tree>
    </div>

    <!-- 新增/修改弹框 -->
    <el-dialog
      :title='dialogTitle'
      :visible.sync='showDialog'
      width='800px'
      :before-close='clearadddata'
    >
      <el-form
        ref='form'
        :rules='rules'
        :model='rowData'
        label-width='160px'
        size='mini'
      >
        <el-form-item label='权限父类：' prop='parentName'>
          <el-input disabled v-model='rowData.parentName'></el-input>
        </el-form-item>
        <el-form-item label='权限类型：' prop='menuType'>
          <el-select
            v-model='rowData.menuType'
            placeholder='--请选择--'
          >
            <el-option
              v-for='item in menuTypes'
              :key='item.value'
              :label='item.label'
              :value='item.value'
            ></el-option>
            <!-- :disabled="item.disabled" -->
          </el-select>
        </el-form-item>
        <el-form-item label='权限名称：' prop='name'>
          <el-input
            v-model='rowData.name'
            placeholder='请输入权限名称'
          ></el-input>
        </el-form-item>
        <el-form-item
          label='路由：'
          prop='href'
          v-if='rowData.menuType != 1 && rowData.menuType != 2'
        >
          <el-input
            v-model='rowData.href'
            placeholder='请输入路由'
          ></el-input>
        </el-form-item>
        <el-form-item label='排序：' prop='sort'>
          <el-input
            v-model.number='rowData.sort'
            placeholder='请输入排序值'
          ></el-input>
        </el-form-item>
        <el-form-item label='权限标识：' v-show='rowData.menuType == 4'>
          <el-input
            v-model.number='rowData.permission'
            placeholder='请输入权限标识'
          ></el-input>
        </el-form-item>
      </el-form>
      <div class='boontbtn'>
        <el-button
          type='primary'
          size='small'
          style='margin: 0 30px'
          @click='save'
        >保存
        </el-button
        >
        <el-button type='info' size='small' @click='clearadddata'
        >关闭
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import '@/assets/css/system.css'
import request from '@/utils/request.js'
import { getTree, findById, update, insert, deleteMenu } from '@/api/competence'

export default {
  data() {
    return {
      searchlist: {},
      permissionName: '', // 权限名称
      isQueryPermissions: false, // 是否点击查询
      isAdd: false, // 是否新增menu
      isEdit: false, // 是否编辑menu
      treedata: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      menuTypes: [
        { value: '1', label: '模块', disabled: true },
        { value: '2', label: '目录', disabled: true },
        { value: '3', label: '菜单', disabled: true },
        { value: '4', label: '动作', disabled: true },
        { value: '5', label: '数据', disabled: true }
      ],
      dialogTitle: '新增',
      flag: 'add',
      showDialog: false,
      rowData: {},
      rules: {
        menuType: [
          {
            required: true,
            message: '请选择权限类型',
            trigger: ['blur', 'change']
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: ['blur', 'change']
          }
        ],
        href: [
          {
            required: true,
            message: '请输入权限路由',
            trigger: ['blur', 'change']
          }
        ],
        sort: [
          {
            required: true,
            message: '请输入排序值',
            trigger: ['blur', 'change']
          },
          {
            type: 'number',
            min: 0,
            message: '排序必须为数字值',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  mounted() {
    this.initTreeData()

    // this.insetMenudataFunc("报名流程", "armsProcedure", 2, 1428, "报名登记");
    // this.insetMenudataFunc("常见问题", "armsProblem", 3, 1428, "报名登记");
    // this.insetMOddataFunc('报名登记', 5, 1421)
    // this.insetBtndataFunc('armsProblem','常见问题', 1431)
  },
  methods: {
    // 增加按钮
    insetBtndataFunc(hrefName, parentName, parentId) {
      insert({
        parentId: parentId,
        name: '新增',
        sort: 1,
        href: '#',
        permission: hrefName + ':add',
        createBy: 1,
        isShow: '1',
        menuType: '4',
        parentName: parentName
      })
      insert({
        parentId: parentId,
        name: '编辑',
        sort: 1,
        href: '#',
        permission: hrefName + ':update',
        createBy: 1,
        isShow: '1',
        menuType: '4',
        parentName: name
      })
      insert({
        parentId: parentId,
        name: '查看',
        sort: 1,
        href: '#',
        permission: hrefName + ':look',
        createBy: 1,
        isShow: '1',
        menuType: '4',
        parentName: name
      })
      insert({
        parentId: parentId,
        name: '删除',
        sort: 1,
        href: '#',
        permission: hrefName + ':delete',
        createBy: 1,
        menuType: '4',
        isShow: '1',
        parentName: name
      })
      insert({
        parentId: parentId,
        name: '审核',
        sort: 1,
        href: '#',
        permission: hrefName + ':audit',
        createBy: 1,
        isShow: '1',
        menuType: '4',
        parentName: name
      })
    },
    // 增加菜单
    insetMenudataFunc(name, href, sort, parentId, parentName) {
      insert({
        name: name,
        sort: sort,
        href: href,
        parentId: parentId,
        isShow: '1',
        createBy: 1,
        updateBy: 1,
        menuType: '3',
        parentName: parentName
      })
    },
    // 增加路由
    insetMOddataFunc(name, sort, parentId) {
      insert({
        name: name,
        sort: sort,
        parentId: parentId,
        isShow: '1',
        menuType: '2',
        parentName: '无父类'
      })
    },
    // 初始化 treeData
    initTreeData() {
      if (!this.isQueryPermissions) {
        this.getTreeData({})
      }
    },

    // 点击查询按钮 设置treeData
    queryPermissions() {
      const name = this.permissionName
      this.isQueryPermissions = true

      this.getTreeData({ name })
      // if (this.isQueryPermissions && name.length > 0) {
      //     this.getTreeData({ name });
      // } else {
      //     this.$message.error("请输入查询内容！");
      // }
    },

    // 获取 treeData
    async getTreeData(data) {
      const res = await getTree(data)
      if (res.code == 200) {
        this.treedata = []
        if (res.content.length) {
          res.content.forEach((item) => {
            var children = []
            if (item.children != null && item.children.length > 0) {
              children = this.formateTree(item.children)
            }
            //1.模块 2.目录 3.菜单 4.动作
            var tag = '模块'
            var css = ''
            if (item.menuType == '2') {
              tag = '目录'
              css = 'info'
            } else if (item.menuType == '3') {
              tag = '菜单'
              css = 'danger'
            } else if (item.menuType == '4') {
              tag = '动作'
              css = 'warning'
            } else if (item.menuType == '5') {
              tag = '数据'
              css = 'success'
            }
            this.treedata.push({
              id: item.id,
              tag: tag,
              css: css,
              href: item.href,
              sort: item.sort,
              parentId: item.parentId,
              value: item.id,
              label: item.name,
              children: children,
              permission: item.permission
            })
          })
        }
      } else if (res.code == '10004') {
        this.$message.error(res.message)
        this.$router.push('/login')
      }
    },

    // 树形列表
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },

    // 树形结果显示内容自定义
    renderContent(h, { node, data, store }) {
      return (
        <span class='tree-span'>
                    <span class='tree-span-label'>
                        <el-tag type={data.css} size='small'>
                            {data.tag}
                        </el-tag>
                      &nbsp;&nbsp;
                      {node.label}
                    </span>
                    <span class='tree-span-path'>{data.href}</span>
                    <span class='tree-span-permission'>{data.permission}</span>
                    <span class='tree-span-sort'>{data.sort}</span>
                    <span class='tree-span-button'>
                        <el-button
                          size='mini'
                          type='primary'
                          on-click={() =>
                            this.addForm(data.id, data.parentId)
                          }
                        >
                            新增下级
                        </el-button>
                        <el-button
                          size='mini'
                          type='success'
                          on-click={() =>
                            this.editForm(data.id, data.parentId)
                          }
                        >
                            编辑
                        </el-button>
                        <el-button
                          size='mini'
                          type='danger'
                          on-click={() => this.deleteMenu(data.id)}
                        >
                            删除
                        </el-button>
                    </span>
                </span>
      )
    },

    formateTree(arr) {
      var temp = []
      if (arr.length > 0) {
        arr.forEach((item) => {
          var children = []
          if (item.children != null && item.children.length > 0) {
            children = this.formateTree(item.children)
          }
          //1.模块 2.目录 3.菜单 4.动作
          var tag = '模块'
          var css = 'warning'
          if (item.menuType == '2') {
            tag = '目录'
            css = 'info'
          } else if (item.menuType == '3') {
            tag = '菜单'
            css = 'danger'
          } else if (item.menuType == '4') {
            tag = '动作'
            css = 'warning'
          } else if (item.menuType == '5') {
            tag = '数据'
            css = ''
          }
          temp.push({
            id: item.id,
            tag: tag,
            css: css,
            href: item.href,
            sort: item.sort,
            parentId: item.parentId,
            value: item.id,
            label: item.name,
            children: children,
            permission: item.permission
          })
        })
      }
      return temp
    },

    // 取消
    clearadddata() {
      this.showDialog = false
    },

    // 新增 弹窗
    async addForm(id, parentId) {
      this.rowData = {}
      this.isEdit = false
      this.isAdd = true
      this.dialogTitle = '新增'

      if (id > 0) {
        const res = await findById({ id })
        if (res.code == 200) {
          this.rowData = res.content
          this.rowData.name = ''
          this.rowData.href = ''
          this.rowData.sort = ''

          if (parentId > 0) {
            this.rowData.parentId = parentId
            this.menuTypes.forEach((item, index) => {
              this.menuTypes[index].disabled = true
            })
            if (res.content.menuType == '1') {
              this.rowData.menuType = '2'
              this.menuTypes[1].disabled = false
              this.menuTypes[2].disabled = false
            } else if (res.content.menuType == '2') {
              this.rowData.menuType = '3'
              this.menuTypes[2].disabled = false
            } else if (res.content.menuType == '3') {
              this.rowData.menuType = '4'
              this.menuTypes[3].disabled = false
              this.menuTypes[4].disabled = false
            } else if (res.content.menuType == '4') {
              this.menuTypes[3].disabled = false
            } else if (res.content.menuType == '5') {
              this.menuTypes[4].disabled = false
            }
            this.showDialog = true
          } else {
            this.rowData.parentId = 0
            this.rowData.parentName = '无父类'
            this.menuTypes.forEach((item, index) => {
              if (item.value == '1') {
                // this.$set(this.menuTypes[1], "disabled", false);
                // this.$set(this.menuTypes[2], "disabled", false);
                this.rowData.menuType = '2'
                this.menuTypes[1].disabled = false
                this.menuTypes[2].disabled = false
              }
            })
            this.showDialog = true
          }
        } else if (res.code == '10004') {
          this.$message.error(res.message)
          this.$router.push('/login')
        } else {
          this.$message.error('数据项加载异常！')
          this.showDialog = false
        }
      } else {
        this.menuTypes[0].disabled = false
        this.showDialog = true
        this.rowData.parentName = '无父类'
      }

      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },

    // 编辑 弹窗
    async editForm(id, parentId) {
      this.isEdit = true
      this.isAdd = false
      this.dialogTitle = '编辑'
      const res = await findById({ id })
      if (res.code == 200) {
        this.rowData = res.content
        this.menuTypes.forEach((item, index) => {
          if (item.value == res.content.menuType) {
            this.menuTypes[index].disabled = false
          } else {
            this.menuTypes[index].disabled = true
          }
        })
        this.showDialog = true
      } else if (res.code == '10004') {
        this.$message.error(res.message)
        this.$router.push('/login')
      } else {
        this.$message.error('数据项加载异常！')
        this.showDialog = false
      }
    },

    // 保存
    async save() {
      // 判断是否为空对象
      let params = this.rowData
      // let params = JSON.stringify(this.rowData); // 1
      let arr = Object.keys(params) // 2
      if (!arr.length) {
        this.$message.error('保存数据为空！')
        return false
      }

      // 修改
      if (this.isEdit) {
        const editData = JSON.parse(JSON.stringify(this.rowData))
        const editRes = await update(editData)
        if (editRes.code == 200) {
          this.showDialog = false
          this.$message({
            message: this.dialogTitle + '成功',
            type: 'success'
          })
          this.getTreeData({})
        } else if (res.code == '10004') {
          this.$message.error(res.message)
          this.$router.push('/login')
        } else {
          this.$message({
            message: this.dialogTitle + '失败：' + editRes.message,
            type: 'error'
          })
        }
      }

      // 新增
      if (this.isAdd) {
        let addData = JSON.parse(JSON.stringify(this.rowData))
        if (addData.id) {
          addData.parentId = addData.id
          delete addData.id
        } else {
          addData.parentId = 0
        }
        // addData.id = '';

        const addRes = await insert(addData).catch((erroe) => {
          this.getTreeData({})
          this.$message({
            message: this.dialogTitle + '失败',
            type: 'error'
          })
          this.showDialog = false
        })
        if (addRes.code == 200) {
          this.showDialog = false
          this.$message({
            message: this.dialogTitle + '成功',
            type: 'success'
          })
          this.getTreeData({})
        } else if (res.code == '10004') {
          this.$message.error(res.message)
          this.$router.push('/login')
        } else {
          this.$message({
            message: this.dialogTitle + '失败：' + addRes.message,
            type: 'error'
          })
        }
      }
    },

    // 删除
    deleteMenu(id) {
      this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          var res = await deleteMenu({ id })
          if (res.code == 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getTreeData({})
          } else if (res.code == '10004') {
            this.$message.error(res.message)
            this.$router.push('/login')
          } else {
            this.$message({
              message: '删除失败：' + res.message,
              type: 'error'
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style lang='less' scoped>
// 深度穿透样式
/deep/ .el-tree-node__content {
  border: 1px solid #ebeef5 !important;
  border-top: 0px;
  height: 40px;
  line-height: 40px;
}

/deep/ .tree-span {
  font-size: 13px;

  .tree-span-path {
    position: absolute;
    right: 630px;
    width: 300px;
    text-align: center;
  }

  .tree-span-permission {
    position: absolute;
    right: 330px;
    width: 300px;
    text-align: center;
  }

  .tree-span-sort {
    position: absolute;
    right: 250px;
    width: 80px;
    text-align: center;
  }

  .tree-span-button {
    position: absolute;
    right: 10px;
    width: 240px;
    text-align: center;
  }
}
</style>
